import { Link } from 'react-router-dom';
import './Home.css';

// Edit this list to change the links under the name.
// Internal links use `to`; external links use `href`.
const LINKS = [
  { label: 'AI Resources', to: '/ai' },
  { label: 'GitHub', href: 'https://github.com/bgerhards' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/brian-gerhards-a666874b/' },
];

function Home() {
  return (
    <main className="home">
      <div className="plate">
        <h1 className="wordmark">Brian Gerhards</h1>
        <span className="spine" aria-hidden="true" />
        <nav className="home-links" aria-label="Sections">
          {LINKS.map(({ label, to, href }, i) => {
            const style = { '--i': i };
            return to ? (
              <Link key={label} to={to} className="home-link spec" style={style}>
                {label}
              </Link>
            ) : (
              <a
                key={label}
                href={href}
                className="home-link spec"
                style={style}
                target="_blank"
                rel="noreferrer"
              >
                {label}
              </a>
            );
          })}
        </nav>
      </div>
    </main>
  );
}

export default Home;
